var $ccd90980ce76d396$exports = {};
$ccd90980ce76d396$exports = {
    "Clear search": `Suche zur\xfccksetzen`
};


export {$ccd90980ce76d396$exports as default};
//# sourceMappingURL=de-DE.mjs.map
